// @flow
import Api, { apiTypes } from 'app/common/api';


// DEPRECATED
// это не нужно использовать. Оно для совместимости
// Нужно использовать app/api

const api: Api = new Api(apiTypes.API_SHOP);

const shopApiRequest = api.commonRequest.bind(api);
export const apiCancelable = {
  request: api.commonRequestCancelable.bind(api),
};

export default shopApiRequest;
